module.exports = __webpack_public_path__ + "static/img/50y.9bf9be1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/50y.jpg
// module id = XruL
// module chunks = 0